export default "__VITE_ASSET__CL3Dzo_0__"